import { HeaderWrapper } from 'layouts';
import type { UserList } from 'models';
import { Image } from 'ui';
import { images } from 'common/utils';

type P = {
  member: UserList;
};

const MemberProfileHeader = ({ member }: P) => (
  <HeaderWrapper
    className="member-profile-header"
    left={
      <Image
        alt="Member cover photo"
        className="member-profile-header__image"
        objectFit="cover"
        src={member.coverPhoto?.url ?? images.default.userCoverPhoto}
      />
    }
  />
);

export default MemberProfileHeader;
